import { FC } from 'react';
import { ReleaseTable } from './ReleaseTable';

export const ReleaseCardContent: FC = () => {
  return <ReleaseTable />;
};
